import type { PropsWithChildren } from 'react';

import cn from 'classnames';

import styles from './Input.module.css';

const stopPropagation = (e: React.SyntheticEvent) => {
  e.stopPropagation();
};

export interface SlotProps {
  side?: 'left' | 'right';
}

/**
 * Wrapper for embed content in input
 * It prevents some events from being propagated to the input so avoid unexpected behavior
 * and to keep the handling of the embed content separate from the input
 */
export const Slot: React.FC<PropsWithChildren<SlotProps>> = ({
  children,
  side = 'right',
}) => {
  return (
    <div
      className={cn(styles['input-slot'], styles[`side-${side}`])}
      onClick={stopPropagation}
      onWheel={stopPropagation}
    >
      {children}
    </div>
  );
};
